module.exports = __webpack_public_path__ + "img/REDMINE.9ef94c6.svg";